module.exports = __webpack_public_path__ + "img/dataUp.f2798df1.png";